import React, { Component } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

export default class DtnPhotoModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            index: props.index,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.index !== prevProps.index) {
            this.setState({ index: this.props.index });
        }
    }

    render() {
        return (
            <div
                className="admin-notes-modal"
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className="admin-notes-modal-body admin-notes-modal-body-wide">
                    <div
                        className="admin-modal-content"
                        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
                    >
                        <h4>{this.props.title}</h4>
                        <hr style={{ width: '100%' }} />
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexGrow: 1,
                                minHeight: 0,
                            }}
                        >
                            {Array.isArray(this.props.media) && this.props.media[this.state.index] ? (
                                <TransformWrapper>
                                    <TransformComponent
                                        wrapperStyle={{
                                            height: '100%',
                                            width: '100%',
                                        }}
                                        contentStyle={{
                                            height: '100%',
                                            width: '100%',
                                        }}
                                    >
                                        <img
                                            style={{
                                                height: '100%',
                                                width: 'auto',
                                                minWidth: 0,
                                                objectFit: 'contain',
                                                marginLeft: 'auto',
                                                marginRight: 'auto',
                                                imageRendering: 'smooth',
                                            }}
                                            src={
                                                this.props.media[this.state.index].url
                                            }
                                        />
                                    </TransformComponent>
                                </TransformWrapper>
                            ) : null}
                        </div>

                        <hr style={{ width: '100%' }} />
                        <div className="admin-modal-notes-footer">
                            <button
                                type="button"
                                title="Previous image"
                                className="btn btn-secondary"
                                style={{ marginRight: '10px' }}
                                onClick={() => this.setState({ index: this.state.index - 1 })}
                                disabled={this.state.index <= 0}
                            >
                                <i className="fas fa-arrow-left" aria-hidden="true" />
                            </button>

                            <button
                                type="button"
                                title="Next image"
                                className="btn btn-secondary"
                                style={{ marginRight: '30px' }}
                                onClick={() => this.setState({ index: this.state.index + 1 })}
                                disabled={
                                    !Array.isArray(this.props.media) || this.state.index >= this.props.media.length - 1
                                }
                            >
                                <i className="fas fa-arrow-right" aria-hidden="true" />
                            </button>

                            <button type="button" className="btn btn-cw-primary ml-2" onClick={this.props.onClose}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
